"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InschrijvenForm = void 0;
var react_1 = __importDefault(require("react"));
var Cart_1 = require("./Cart");
var LeerlingForm_1 = require("./LeerlingForm");
var OuderForm_1 = require("./OuderForm");
var BetalenForm_1 = require("./BetalenForm");
var useCart_1 = require("../hooks/useCart");
function InschrijvenForm() {
    var _this = this;
    var _a;
    var leerlingState = react_1.default.useState({});
    var ouderState = react_1.default.useState({});
    var markState = react_1.default.useState([]);
    var ref = react_1.default.useRef(null);
    var cart = (0, useCart_1.useCart)().cart;
    var trainingenCount = (_a = cart === null || cart === void 0 ? void 0 : cart.trainingen.length) !== null && _a !== void 0 ? _a : 0;
    var handleSubmit = function (method) { return function (e) { return __awaiter(_this, void 0, void 0, function () {
        var valid, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // check form validation
                    e.preventDefault();
                    valid = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.reportValidity();
                    if (!valid) return [3 /*break*/, 2];
                    console.log("submit", method, ouderState[0], leerlingState[0]);
                    return [4 /*yield*/, (0, useCart_1.postFormData)("shop_handler.php", __assign(__assign(__assign({ task: "inschrijvenNieuw", betaling: method }, ouderState[0]), leerlingState[0]), { marks: markState[0] }))];
                case 1:
                    result = _b.sent();
                    try {
                        // redirect if result is a url
                        new URL(result);
                        window.location.href = result;
                    }
                    catch (e) {
                        console.log("result is not a url", result);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    console.log("form invalid");
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }; };
    return (react_1.default.createElement("div", { className: "card-body" },
        react_1.default.createElement("form", { ref: ref },
            react_1.default.createElement("div", { className: "cart" },
                react_1.default.createElement("h4", { className: "card-title" }, "Overzicht"),
                !!trainingenCount && (react_1.default.createElement("p", null, "Vul hieronder je gemiddelde SE cijfer in.")),
                react_1.default.createElement(Cart_1.Cart, { state: markState })),
            react_1.default.createElement(LeerlingForm_1.LeerlingForm, { state: leerlingState }),
            react_1.default.createElement(OuderForm_1.OuderForm, { state: ouderState }),
            react_1.default.createElement(BetalenForm_1.BetalenForm, { onSubmit: handleSubmit }))));
}
exports.InschrijvenForm = InschrijvenForm;
